import apiClient from "./apiClient";

const menuService = {
  async getMyMenus() {
    const response = await apiClient.get("/menus/my-menus");
    return response.data;
  },

  async getMenus() {
    const response = await apiClient.get("/menus");
    return response.data?.data || response.data;
  },

  async getMenuTree() {
    const response = await apiClient.get("/menus/tree");
    return response.data?.data || response.data;
  },

  async getMenuById(id) {
    const response = await apiClient.get(`/menus/${id}`);
    return response.data?.data || response.data;
  },

  async createMenu(payload) {
    const response = await apiClient.post("/menus", payload);
    return response.data?.data || response.data;
  },

  async updateMenu(id, payload) {
    const response = await apiClient.patch(`/menus/${id}`, payload);
    return response.data?.data || response.data;
  },

  async deleteMenu(id) {
    const response = await apiClient.delete(`/menus/${id}`);
    return response.data?.data || response.data;
  },
};

export default menuService;
